import { Container } from 'lucide-react';
import React from 'react';

export const MantenedoresHeader: React.FC = () => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-4 sm:px-7 py-6 border-b border-gray-200 shrink-0 bg-white">
            <div>
                <h1 className="text-[20px] font-bold flex items-center gap-[10px] m-0 text-gray-900">
                    <Container size={22} color="#4f6df5" strokeWidth={2} />
                    Mantenedores
                </h1>
                <p className="text-[13px] text-gray-500 mt-[2px] m-0">
                    Gestiona las categorías y parámetros globales de la plataforma.
                </p>
            </div>
        </div>
    );
};